import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { Circle } from 'progressbar.js';

export default class Databases extends Component {
    state = {
        databases: [
            {
                id: 'postgresql',
                name: 'PostgreSQL',
                percentage: 0.8
            }, {
                id: 'mysql',
                name: 'MySQL',
                percentage: 0.6
            }, {
                id: 'mongo',
                name: 'MongoDB',
                percentage: 0.7
            }, {
                id: 'redis',
                name: 'Redis',
                percentage: 0.55
            }
        ]
    }

    componentDidMount() {
        const { databases } = this.state;
        databases.forEach((database) => {
            const { name, id, percentage} = database;
            this.createCircle(name, id, percentage);
        });        
    }

    createCircle(name, id, percentage) {
        let startColor = '#5b8fdb';
        let endColor = '#5b8fdb';

        let circle = new Circle(`#${id}`, {
            color: startColor,
            trailColor: '#eee',
            trailWidth: 4,
            duration: 2000,
            easing: 'bounce',
            strokeWidth: 4,
            text: {
                value: name,
                className: 'progressbar__label'
            },
            // Set default step function for all animate calls
            step: function (state, circle) {
                circle.path.setAttribute('stroke', state.color);
            }
        });

        circle.animate(percentage, {
            from: {
                color: startColor
            },
            to: {
                color: endColor
            }
        });
    }
    render() {
        return (
            <Grid.Column widescreen={8} largeScreen={8} computer={8} tablet={16} mobile={16}>
                <h3>Databases</h3>
                <Grid>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <div id="postgresql" style={{width: '100px'}}></div>
                        </Grid.Column>
                        <Grid.Column>
                            <div id="mysql" style={{width: '100px'}}></div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <div id="mongo" style={{width: '100px'}}></div>
                        </Grid.Column>
                        <Grid.Column>
                            <div id="redis" style={{width: '100px'}}></div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>                
            </Grid.Column>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Databases.js